import { Component, Input, OnInit } from '@angular/core';
import { BooleanCons } from '../../constants/const';

@Component({
  selector: 'app-hoffman-message',
  templateUrl: './hoffman-message.component.html',
  styleUrls: ['./hoffman-message.component.scss']
})
export class HoffmanMessageComponent implements OnInit {
  @Input() hoffmanTextFlag = BooleanCons.false;
  @Input() hoffmanText = 'Disponible solo para venta en <strong>Monterrey</strong>';
  constructor() { }

  ngOnInit(): void {
  }

}
